import { AccessTokenManager } from '@spotify-internal/access-token';
import { getSpotifyClientId } from '@mrkt/features/env';
import { isSpotifyNet } from './constants';

const webgateDomain = isSpotifyNet
  ? 'https://wgint.spotify.net'
  : 'https://generic.wg.spotify.com';

export const accessTokenManager = new AccessTokenManager({
  url: `${webgateDomain}/creator-auth-proxy/v1/web/token?client_id=${getSpotifyClientId()}`,
  options: { credentials: 'include' },
});
